
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/avis-parents',
    element: <TestimonialsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
